import type { RepositoryResponseDetailed } from '@emma/api_client/types';
import { Dropdown } from '@lego/klik-ui';
import { useRepository } from '@/hooks/repository';
import type { StoreService } from '@/hooks/store';

type WorkspaceServiceDropdownProps = {
  repositoryId: number;
  workspaceId: number;
  onSelectedServicesChange: (selectedService: RepositoryResponseDetailed | StoreService) => void;
  type: 'WorkspaceService';
};

type StoreServiceDropdownProps = {
  service: StoreService;
  onSelectedServicesChange: (selectedService: RepositoryResponseDetailed | StoreService) => void;
  type: 'StoreService';
};

type ServiceDropdownProps = WorkspaceServiceDropdownProps | StoreServiceDropdownProps;

const ServiceTagDropdown = ({
  repository,
  onSelectedServicesChange,
}: {
  repository: StoreService | RepositoryResponseDetailed;
  onSelectedServicesChange: (selectedService: RepositoryResponseDetailed | StoreService) => void;
}) => (
  <Dropdown
    onChange={(tagValue: string) => {
      const selectedTag = repository.tags.find((t) => t.tag === tagValue);
      onSelectedServicesChange({
        imageName: repository.imageName,
        name: repository.name,
        tags: selectedTag ? [selectedTag] : [{ tag: tagValue, digest: '' }],
      });
    }}
    size="sm"
  >
    {repository.tags.map((entry) => (
      <Dropdown.Option key={entry.tag} value={entry.tag}>
        {entry.tag}
      </Dropdown.Option>
    ))}
  </Dropdown>
);

const WorkspaceServiceDropdown = ({
  workspaceId,
  repositoryId,
  onSelectedServicesChange,
}: WorkspaceServiceDropdownProps) => {
  const { data, isLoading, error } = useRepository(workspaceId, repositoryId);

  if (!data || isLoading || error) {
    return (
      <Dropdown isDisabled={true} placeholder="Loading..." size="sm">
        <Dropdown.Option>...</Dropdown.Option>
      </Dropdown>
    );
  }

  return (
    <ServiceTagDropdown onSelectedServicesChange={onSelectedServicesChange} repository={data} />
  );
};

const StoreServiceDropdown = ({ service, onSelectedServicesChange }: StoreServiceDropdownProps) => (
  <ServiceTagDropdown onSelectedServicesChange={onSelectedServicesChange} repository={service} />
);

export const AppWizardDropdown = (props: ServiceDropdownProps) => {
  if (props.type === 'WorkspaceService') {
    return <WorkspaceServiceDropdown {...props} />;
  }
  return <StoreServiceDropdown {...props} />;
};
